import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import awardeestore from '../../AHAH_Awardee_Form/stores/awardeestore';

const ProtectedRoute = ({ stepKey, component: Component, ...rest }) => {
  const allowed = awardeestore.isStepAllowed(stepKey);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (allowed) {
          return <Component {...props} />;
        }
        // Only reset when actually redirecting unauthorized user
        awardeestore.reset();
        return <Redirect to="/" />;
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  stepKey: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired
};

export default ProtectedRoute;